import React, { useContext, useEffect, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button } from "react-bootstrap";
// Componentes
import VistaActividades from "../vistas/VistaActividades";
import FormActividades from "../formularios/FormActividades";
// Contexto
import { ModalContext } from "../../../../context/modalContext";
import { AlertBoxContext } from "../../../../context/alertBoxContext";
// Custom spinner
import CustomSpinner from "../../../generic/CustomSpinner";
// jquery
import $ from "jquery";
// Utils
import { actividades } from "../../../../contexto";

const Actividades = ({ idProvincia, idMision, categoriaMision }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Datos de ingresos de la misión
  const [datosActividades, setDatosActividades] = useState([]);
  // Spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);

  useEffect(() => {
    handleGetDatosActividades();
  }, []);

  // Obtiene los datos de actividades de la obra
  const getDatosActividades = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}/actividades`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Edita los datos de actividades de una misión
  const postDatosActividades = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/misiones/${idMision}/actividades`,
      method: "POST",
      contentType: "application/json; charset=utf-8",

      xhrFields: {
        withCredentials: true,
      },
      data: JSON.stringify(data),
    };
    return $.ajax(settings);
  };

  // Manejador para obtener los datos de la misión de las actividades
  const handleGetDatosActividades = () => {
    setLoading(true);
    getDatosActividades()
      .then((response) => {
        setDatosActividades(response.items);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        // props?.ErrorHandling();
      });
  };

  // Manejador para el put de los datos las actividades
  const handlePostDatosActividades = (data) => {
    modalSetShow(false);
    setLoading(true);
    // Hacemos el put para los datos de las actividades
    postDatosActividades(data)
      .then(() => {
        setLoading(false);
        // TODO deberiamos actualizar los datos en lugar de volverlos a pedir
        handleGetDatosActividades();
        addAlert("Exito", "Se han editado las actividades de la misión correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        // props?.ErrorHandling();
      });
  };

  return (
    <div className="position-relative">
      <CustomSpinner animation={"border"} loading={loading} />
      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              Actividades
            </Accordion.Toggle>
            <Button
              variant="outline-primary"
              size="sm"
              className="float-right mr-4"
              onClick={() => {
                modalSetShow(true, "80%");
                modalSetTitle("Actividades de la misión");
                modalSetContent(<FormActividades defaultValues={datosActividades} submissionHandler={handlePostDatosActividades} objActividades={actividades[categoriaMision]} />);
              }}
            >
              Editar
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className={"bg-light"}>
              <VistaActividades datosActividades={datosActividades} objActividades={actividades[categoriaMision]} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Actividades;
